import React, { Component } from 'react';
import { Button } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ListTable from '../../../../common/tables/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import {
  getColumns,
  getData,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/EdiRfidAuditRequestListSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import EdiRfidAuditExecutionListContainer from '../../execution/containers/EdiRfidAuditRequestExecutionListContainer';
import EdiRfidAuditDelete from '../delete/containers/EdiRfidAuditDelete';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { EdiRfidAuditRequestListContainerStyle } from './EdiRfidAuditRequestListContainer.styles';

class EdiRfidAuditRequestListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteConfirmModal: false,
    };
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteConfirmModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteConfirmModal: false,
    });
  }

  deleteAuditRequest = () => {
    this.setState({
      showDeleteConfirmModal: true,
    });
  }

  render() {
    const { showDeleteConfirmModal } = this.state;
    return (
      <div className="general-content-container">
        <h1 className="title-div">EDI-RFID AUDIT</h1>
        <EdiRfidAuditRequestListContainerStyle>
          <div style={{ marginLeft: '30px' }}>
            <Link to={{ pathname: 'edi-rfid-audit/create' }}>
              <Button className="action-buttons">
                Create New EDI-RFID Audit Report
              </Button>
            </Link>
            <Button
              className={`action-buttons primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
              disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
              onClick={this.deleteAuditRequest}
            >
              EDI-RFID AUDIT REQUESTS BULK DELETE
            </Button>
          </div>
          <ListTable
            listId={TableDefinitions.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.id}
            loading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            keyField="requestId"
            selectCheckbox
            pagination
            downloadType={downloadTypes.EXCEL}
            getSubComponentProps={(row) => (
              <div style={{ padding: '20px' }}>
                <EdiRfidAuditExecutionListContainer
                  row={row}
                />
              </div>
            )}
          />
        </EdiRfidAuditRequestListContainerStyle>
        {showDeleteConfirmModal && (
          <EdiRfidAuditDelete
            closeDialog={this.hideDeleteFormModal}
            openDialog={this.showDeleteFormModal}
            row={this.props.checkedRows}
          />
        )}
      </div>
    );
  }
}

EdiRfidAuditRequestListContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditRequestListContainer);
